declare global {
  var KYC: EnvVariablesProps;
}

type EnvVariablesProps = {
  REACT_APP_PROXY_BASE_URL: string;
  REACT_APP_AUTH_URL: string;
  REACT_APP_USERNAME: string;
  REACT_APP_KEY: string;
};

const getConfigValue = (key: keyof EnvVariablesProps, defaultValue: string) => {
  if (global.KYC && global.KYC[key] !== defaultValue) {
    return global.KYC[key];
  }

  if (process.env.NODE_ENV !== "production" && process.env[key]) {
    return String(process.env[key]);
  }

  console.log(`The key ${key} in index.html should be replaced!`);
  return global.KYC && global.KYC[key];
};

const config: EnvVariablesProps = {
  REACT_APP_PROXY_BASE_URL: getConfigValue(
    "REACT_APP_PROXY_BASE_URL",
    "VARPROXYBASEURL"
  ),
  REACT_APP_AUTH_URL: getConfigValue("REACT_APP_AUTH_URL", "VARPROXYAUTHURL"),
  REACT_APP_USERNAME: getConfigValue("REACT_APP_USERNAME", "VARPROXYUSERNAME"),
  REACT_APP_KEY: getConfigValue("REACT_APP_KEY", "VARPROXYKEY"),
};

export default config;
